// extracted by css-extract-rspack-plugin
export default {"fileUploadContainer":"Presenter__fileUploadContainer--QPpZ1"};